module.exports = __webpack_public_path__ + "img/icon-twitter-dark.d50a85c3.svg";